<template>
  <div id="app" v-if="showPage">
    <router-view></router-view>
  </div>
</template>
<script>
import { getUrlParams } from "@/utils";
import api from "@api/index";
export default {
  data() {
    return {
      showPage: false,
    };
  },
  async created() {
    window.addEventListener("pagehide", () => {
      this.$store.commit("setIsReload", true);
    });
    const routerQuery = getUrlParams(window.location.href);
    const { code } = routerQuery;
    if (code) {
      await api.getTokenByCode(code);
    }
    this.showPage = true;
  },
};
</script>

<style lang="less">
html,
body {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  background-color: #f7f7f8;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: inherit;
}
@font-face {
  font-family: "DIN";
  src: url("https://static0.xesimg.com/platform-fe/trade/common/files/fonts/DIN-Regular.otf")
    format("opentype");
}

@font-face {
  font-family: "DIN-Bold";
  src: url("https://static0.xesimg.com/platform-fe/trade/common/files/fonts/DIN-Bold.otf")
    format("opentype");
}
@font-face {
  font-family: "DIN-Medium";
  src: url("https://static0.xesimg.com/platform-fe/trade/common/files/fonts/DIN-Medium.otf")
    format("opentype");
}
@font-face {
  font-family: "DIN-Bold-700";
  src: url("https://static0.xesimg.com/trade/uploads/fonts/D-DIN-PRO-700-Bold.otf")
    format("opentype");
}
@font-face {
  font-family: "xes";
  src: url("https://static0.xesimg.com/platform-fe/trade/common/files/fonts/xueersi.ttf")
    format("truetype");
  src: url("https://static0.xesimg.com/platform-fe/trade/common/files/fonts/xueersi.otf")
    format("opentype");
}
@font-face {
  font-family: "FZZhengHeiS-EB-GB";
  src: url("https://static0.xesimg.com/platform-fe/trade/common/files/fonts/FZZhengHeiS-EB-GB.TTF")
    format("truetype");
}
.xes-font {
  font-family: xes;
}
</style>
